module.exports = __webpack_public_path__ + "static/media/kaligreen.2da60333.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/climasense/cenicilla_tomate/preventiva/kaligreen.png
// module id = 2389
// module chunks = 3